export const environment = {
  production: false,
  SERVICE_BASE: '',
  SERVICE_CONTEXT: '/api'
};
